module.exports = (__webpack_require__(8))(72);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/body/AdminView.js from dll-reference girder_lib
// module id = 969
// module chunks = 0